import type { TypographyOptions } from "@mui/material/styles/createTypography";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    poster: React.CSSProperties;
  }
  interface TypographyVariantsOptions {
    poster?: React.CSSProperties;
  }
}
declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    poster: true;
  }
}

export const typography: TypographyOptions = {
  fontFamily: "Averta, Helvetica Neue, Helvetica, Arial, Roboto, sans-serif",
  h1: {
    fontSize: 50,
  },
  poster: {
    fontSize: 30,
  },
  subtitle1: {
    fontSize: 21,
  },
};
